<template>
  <div>
    <nav-bar class="home-nav">
      <div slot="left" @click="onClickLeft">返回</div>
      <div slot="center">音乐</div>
    </nav-bar>

    <form action="/">
      <van-search
        v-model="value"
        show-action
        placeholder="请输入搜索关键词"
        @search="onSearch"
        @cancel="onCancel"
      />
    </form>
    <div style="overflow-y: scroll">
      <van-cell-group>
        <van-cell v-for="(item,index) in musicList" :key="index" :title="item.name" value="内容" :label="item.album.name">
          <van-button type="info" @click="playMusic(item.id)">播放</van-button>
        </van-cell>
      </van-cell-group>
    </div>
    <div style="padding-top: 100px"></div>
    <!--    <back-top @click.native="musicClick"></back-top>-->
    <div style="text-align: center;position: fixed; bottom: 0px;width: 100%">
      <audio :src="musicUrl" ref='audio' controls autoplay loop></audio>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import NavBar from "components/common/navbar/NavBar";
import BackTop from "components/content/backTop/BackTop";
import {Search, Form, Cell, CellGroup, Button} from "vant";


Vue.use(Search);
Vue.use(Form);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Button);
export default {
  name: "Music",
  components: {
    NavBar, BackTop
  },
  data() {
    return {
      value: "",
      musicList: [],
      musicId: "",
      musicUrl: "",
      isPlaying: false
    }
  },
  created() {
    let that = this;
    axios.get("https://autumnfish.cn/search?keywords=" + "王嘉尔").then(function (datas) {
      that.musicList = [];
      that.musicList.push(...datas.data.result.songs)
    })
  },
  methods: {
    onSearch() {
      let that = this;
      axios.get("https://autumnfish.cn/search?keywords=" + this.value).then(function (datas) {
        that.musicList = [];
        that.musicList.push(...datas.data.result.songs)
      })
    },
    onCancel() {

    },
    musicClick() {
    },
    playMusic(id) {
      var that = this;
      axios.get("https://autumnfish.cn/song/url?id=" + id).then(
        function (response) {
          // console.log(response);
          // console.log(response.data.data[0].url);
          that.musicUrl = response.data.data[0].url;
        },
        function (err) {
        }
      );
    },
    onClickLeft() {
      this.$router.replace("/home");
    }
  }
}
</script>

<style scoped>
.home-nav {
  /*background-color: var(--color-tint);*/
  /*background-image: linear-gradient(#e66465, #9198e5);*/


  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background: #ee9ca7; /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, rgb(238, 156, 167), rgb(255, 221, 225));
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, rgb(238, 156, 167), rgb(255, 221, 225));
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: #fff;

  /*在使用浏览器原生滚动时，为了让导航不跟随一起滚动*/
  /*position: fixed;*/
  /*left: 0;*/
  /*right: 0;*/
  /*top: 0;*/
  /*z-index: 9;*/
}
</style>
